import React from 'react';
import {
  Alert,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const PIIHistoryHelp = ({ t }) => {
  const [open, setOpen] = React.useState(true);
  const collapseId = 'pii-history-help';

  return (
    <Alert
      icon={<HelpOutlineIcon sx={{ mt: 0.5 }} />}
      severity="info"
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: 2,
        '& .MuiAlert-message': { width: '100%' },
        py: 1.5,
        px: 2,
      }}
      action={
        <IconButton
          size="small"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls={collapseId}
          aria-label={
            open
              ? t?.('admin.pii.historyHelp.collapse', 'Skryť návod')
              : t?.('admin.pii.historyHelp.expand', 'Zobraziť návod')
          }
          sx={{ mt: 0.5, color: 'inherit' }}
        >
          {open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
        </IconButton>
      }
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
        {t?.('admin.pii.historyHelp.title', 'Ako pracovať s protokolmi')}
      </Typography>

      <Collapse in={open} timeout="auto" id={collapseId}>
        <Stack spacing={1.5} sx={{ mt: 1.5 }}>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'admin.pii.historyHelp.p1',
              'V tejto časti si viete vytvoriť a stiahnuť protokol z procesu anonymizácie.'
            )}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'admin.pii.historyHelp.p2',
              'Stačí vybrať záznam a kliknúť na „Stiahnuť protokol“. Týmto si stiahnete protokol pre archiváciu v PDF.'
            )}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
            {t?.(
              'admin.pii.historyHelp.p3',
              'Ak chcete zobraziť detaily anonymizácie v textovej podobe, kliknite na šípku na konci záznamu.'
            )}
          </Typography>
        </Stack>
      </Collapse>
    </Alert>
  );
};

export default PIIHistoryHelp;